/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Image } from 'ui/atoms/Image';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { InfiniteScroller } from 'ui/molecules/InfiniteScroller/InfiniteScroller';

import styles from './TrustedBy.module.scss';

type Props = {
  title?: string;
};

const LOGOS = [
  'allianz',
  'amazon',
  'informa',
  'lseg',
  'sap',
  'schneider',
  'statista',
  'uber',
  'jp-morgan',
  'goldman-sachs',
  'experian',
  'kroll',
  'sourcescrub',
  'quantifind',
  'bdo',
  'zeizz',
];

const logoElements = LOGOS.map((logo, idx) => (
  <div key={`${logo}-${idx}`} className={styles.logoCard}>
    <Image width={96} height={32} src={`img/customers/${logo}.svg`} alt={`${logo} logo`} />
  </div>
));

export const TrustedBy = ({ title }: Props) => {
  const { t } = useInt();

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <TitleBlock extra={title ?? t('Trusted by Leading Sales Teams')} className={styles.intro} />
      </div>

      <InfiniteScroller
        className={styles.scroller}
        items={logoElements}
        slideWidth={150}
        slideGap={20}
        animationDuration={30}
      />
    </section>
  );
};
